(function () {
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function nowIn(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz || 'America/Mexico_City', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: map[o.weekday], min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    } catch (e) { var d = new Date(); return { day: d.getDay(), min: d.getHours() * 60 + d.getMinutes() }; }
  }
  function parseRange(txt) {
    if (!txt) return null;
    var m = txt.replace(/\s/g, '').match(/(\d{1,2})(?::(\d{2}))?(am|pm)?[-–a](\d{1,2})(?::(\d{2}))?(am|pm)?/i);
    if (!m) return null;
    function toMin(h, mm, ap) { h = parseInt(h, 10); mm = parseInt(mm || '0', 10); if (ap) { ap = ap.toLowerCase(); if (ap === 'pm' && h < 12) h += 12; if (ap === 'am' && h === 12) h = 0; } return h * 60 + mm; }
    return { from: toMin(m[1], m[2], m[3]), to: toMin(m[4], m[5], m[6]) };
  }
  function hoursFor(card, day) { return card.getAttribute('data-' + (day === 0 ? 'h0' : day === 6 ? 'h6' : 'h1')) || ''; }
  function fmt(min) { var h = Math.floor(min / 60), m = min % 60; return h + ':' + (m < 10 ? '0' : '') + m; }
  function km(a, b, c, d) { var R = 6371, x = (c - a) * Math.PI / 180, y = (d - b) * Math.PI / 180; var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(y / 2) * Math.sin(y / 2); return 2 * R * Math.asin(Math.sqrt(h)); }

  function init(root) {
    if (root._lmInit) return; root._lmInit = true;
    var cards = [].slice.call(root.querySelectorAll('[data-card]'));

    var promo = root.querySelector('.lm-suc__promo');
    if (promo) {
      var until = promo.getAttribute('data-promo-until'), show = true;
      if (until) { var end = new Date(until + 'T23:59:59'); if (!isNaN(end) && new Date() > end) show = false; }
      promo.hidden = !show;
    }

    function updateStatus() {
      cards.forEach(function (card) {
        var el = card.querySelector('[data-status]');
        var n = nowIn(card.getAttribute('data-tz'));
        [].forEach.call(card.querySelectorAll('[data-row]'), function (r) { r.classList.remove('is-today'); });
        var row = card.querySelector('[data-row="' + (n.day === 0 ? 0 : n.day === 6 ? 6 : 1) + '"]');
        if (row) row.classList.add('is-today');
        var openFrom = card.getAttribute('data-open-from');
        if (openFrom) {
          var od = new Date(openFrom + 'T00:00:00');
          if (!isNaN(od) && new Date() < od) {
            el.className = 'lm-card__status is-soon';
            el.innerHTML = 'Próxima apertura <span class="lm-card__status-sub">· ' + od.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }) + '</span>';
            el.hidden = false; return;
          }
        }
        if (!hoursFor(card, 1) && !hoursFor(card, 6) && !hoursFor(card, 0)) { el.hidden = true; return; }
        var today = parseRange(hoursFor(card, n.day));
        if (today && n.min >= today.from && n.min < today.to) {
          el.className = 'lm-card__status is-open';
          el.innerHTML = 'Abierto ahora <span class="lm-card__status-sub">· cierra a las ' + fmt(today.to) + '</span>';
        } else {
          var next = '';
          if (today && n.min < today.from) next = 'abre hoy a las ' + fmt(today.from);
          else for (var i = 1; i <= 7; i++) {
            var d = (n.day + i) % 7, r = parseRange(hoursFor(card, d));
            if (r) { next = 'abre ' + (i === 1 ? 'mañana' : 'el ' + DAYS[d]) + ' a las ' + fmt(r.from); break; }
          }
          el.className = 'lm-card__status is-closed';
          el.innerHTML = 'Cerrado' + (next ? ' <span class="lm-card__status-sub">· ' + next + '</span>' : '');
        }
        el.hidden = false;
      });
    }
    updateStatus();
    setInterval(updateStatus, 60000);

    /* ---------- Google Maps embebido (sin API key) ---------- */
    var mapEl = root.querySelector('[data-map]');
    var frame = document.createElement('iframe');
    frame.setAttribute('loading', 'lazy');
    frame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    frame.setAttribute('allowfullscreen', '');
    frame.style.cssText = 'border:0;width:100%;height:100%;display:block';
    mapEl.appendChild(frame);
    var current = null;

    function setActive(card, scrollMap) {
      if (!card) return;
      cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
      if (current !== card) {
        current = card;
        var q = card.getAttribute('data-lat') + ',' + card.getAttribute('data-lng');
        frame.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(q) + '&z=16&hl=es&output=embed';
        frame.title = 'Mapa de Litemart ' + card.getAttribute('data-name');
      }
      if (scrollMap && window.innerWidth <= 980) root.querySelector('.lm-suc__mapbox').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var chips = [].slice.call(root.querySelectorAll('[data-filter]'));
    function applyFilter(f) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-filter') === f ? 'true' : 'false'); });
      var visible = cards.filter(function (card) { var s = f === 'all' || card.getAttribute('data-city') === f; card.hidden = !s; return s; });
      if (visible.length && visible.indexOf(current) === -1) setActive(visible[0], false);
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { applyFilter(c.getAttribute('data-filter')); }); });

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-focus]');
      if (btn) btn.addEventListener('click', function () { setActive(card, true); });
      card.addEventListener('click', function (e) { if (!e.target.closest('a,button')) setActive(card, false); });
    });

    var initial = null;
    if (location.hash) { var t = root.querySelector(location.hash); if (t && t.hasAttribute('data-card')) initial = t; }
    setActive(initial || cards[0], false);

    var promoLink = root.querySelector('[data-promo-link]');
    if (promoLink && (promoLink.getAttribute('href') || '').charAt(0) === '#') {
      promoLink.addEventListener('click', function (e) {
        var t = root.querySelector(promoLink.getAttribute('href'));
        if (t && t.hasAttribute('data-card')) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); setActive(t, false); }
      });
    }

    var nearBtn = root.querySelector('[data-near]');
    if (nearBtn) {
      if (!navigator.geolocation) { nearBtn.hidden = true; return; }
      nearBtn.addEventListener('click', function () {
        nearBtn.textContent = 'Buscando tu ubicación…';
        navigator.geolocation.getCurrentPosition(function (pos) {
          var me = pos.coords;
          cards.forEach(function (c) { c._d = km(me.latitude, me.longitude, parseFloat(c.getAttribute('data-lat')), parseFloat(c.getAttribute('data-lng'))); var s = c.querySelector('[data-dist]'); if (s) s.textContent = ' · a ' + (c._d < 10 ? c._d.toFixed(1) : Math.round(c._d)) + ' km'; });
          var sorted = cards.slice().sort(function (a, b) { return a._d - b._d; });
          var list = root.querySelector('[data-list]');
          sorted.forEach(function (c) { list.appendChild(c); });
          applyFilter('all');
          setActive(sorted[0], true);
          nearBtn.textContent = '📍 Ordenadas por cercanía';
        }, function () { nearBtn.textContent = '📍 No pudimos obtener tu ubicación'; }, { timeout: 8000 });
      });
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-lm-suc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();